// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1eUR6","col":"styles_col__1h8gn"};